import { Injectable } from '@angular/core';
// import { Http, Response } from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { lastValueFrom, Observable } from 'rxjs';
import { UtilityService } from './utility.service';
//import 'rxjs/add/operator/map';

@Injectable()
export class AuthenticationService{
    redirectUrl:string = "";
    user:string = "";
    tempUser:any;
    pageload = 0;
    constructor( private httpC : HttpClient, private utilService:UtilityService){}

    // login(userName:string, password:string):Observable<Object>{
    //     console.log("AuthService: Attempting to loggin");
    //     const body = new HttpParams()
    //         .set('username', userName)
    //         .set('password', password);
        
    //     return this.postRequest(this.utilService.getBaseUrl()+'auth/login', body);
    //     //return this.httpC.post('/warehouseservice/user/login', body.toString(),{headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')});
    //     //return this.httpC.post<any>('/api/authenticate', { username: userName, password: password })
    // }

    startVerification(usernam:string){
        return new Promise((resolve,reject)=>{
            const body = new HttpParams()
            let result = lastValueFrom(this.httpC.get(this.utilService.getBaseUrl()+'auth/login?username='+usernam ));
                result.then((data:any)=>{
                    console.log(data);
                    resolve(data);
                }).catch((error)=>{
                    console.log(error);
                    reject(error);
                })
        });
    }

    verify(state:string, code:string){
        return new Promise((resolve,reject)=>{
            const body = new HttpParams()
            let result = lastValueFrom(this.httpC.get(this.utilService.getBaseUrl()+'auth/verify?state='+state+'&code='+code ));
                result.then((data:any)=>{
                    console.log(data);
                    resolve(data);
                }).catch((error)=>{
                    console.log(error);
                    reject(error);
                })
        });
    }

    status(username:string, token:string){
        return lastValueFrom(this.httpC.get(this.utilService.getBaseUrl()+'auth/status?username='+username+'&token='+token));
        // return new Promise((resolve,reject)=>{
        //     const body = new HttpParams()
        //     let result = lastValueFrom(this.httpC.get(this.utilService.getBaseUrl()+'auth/status?state='+username+'&code='+token));
        //         result.then((data:any)=>{
        //             console.log(data);
        //             resolve(data);
        //         }).catch((error)=>{
        //             console.log(error);
        //             reject(error);
        //         })
        // });
    }

    // logout(token:string, username:string){
    //     const body = new HttpParams()
    //     .set('token', token)
    //     .set('username', username);
    //     if(token.length>0){
    //         this.postRequest(this.baseUrl+'/logout',body).subscribe();
    //     }

    // }

    // userEvent(token:string,detail:string, description:string, nodeName:string){
    //     const body = new HttpParams()
    //         .set('token', token)
    //         .set('detail', detail)
    //         .set('description',description)
    //         .set('nodeName',nodeName);
    //     return this.postRequest(this.baseUrl+'/event',body);
    //     //return this.httpC.post<any>('/api/userEvent',{token:token, event:event});
    // }


    private postRequest(url:string,body:HttpParams){
        return this.httpC.post(url, body.toString(),{headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')});
    }

}